<script>
import SessionContainer from '@/modules/games-shared/SessionContainer';
import config from './config';

export default {
    name: 'GameShopping',

    extends: SessionContainer,
    config
};
</script>
